import React, { useState, useCallback } from 'react';
import FlightTrackingContext from './FlightTrackingContext';
import { searchFlight } from '../../services/flight-tracking/flightService';

const FlightTrackingState = (props) => {
  const [flightData, setFlightData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const trackFlight = useCallback(async (flightNumber, date) => {
    setLoading(true);
    setError(null);
    try {
      const data = await searchFlight(flightNumber, date);
      if (data.success && data.data && data.data.length > 0) {
        const clean = String(flightNumber || '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
        const bestMatch = data.data.find(f => {
          const iata = String(f.flight?.iata || '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
          const icao = String(f.flight?.icao || '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
          const num = String(f.flight?.number || '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
          return iata === clean || icao === clean || num === clean;
        }) || data.data.find(f => {
          const csIata = String(f.flight?.codeshared?.flight_iata || '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
          const csIcao = String(f.flight?.codeshared?.flight_icao || '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
          const csNum = String(f.flight?.codeshared?.flight_number || '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
          return csIata === clean || csIcao === clean || csNum === clean;
        }) || data.data[0];

        setFlightData(bestMatch);
      } else {
        setFlightData(null);
        setError('No flight data found.');
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Failed to fetch flight status.');
      setFlightData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const clearFlightData = useCallback(() => {
    setFlightData(null);
    setError(null);
  }, []);

  return (
    <FlightTrackingContext.Provider
      value={{
        flightData,
        loading,
        error,
        trackFlight,
        clearFlightData
      }}
    >
      {props.children}
    </FlightTrackingContext.Provider>
  );
};

export default FlightTrackingState;
